// extracted by mini-css-extract-plugin
export default {"app":"Charity_app__qyne9","headerBar":"Charity_headerBar__FyRE4","view":"Charity_view__ZCGwb","customTable":"Charity_customTable__Aw-eA"};